import { Pipe, PipeTransform } from '@angular/core';
import { TabloMember } from '@ui/tablo-generator/types';

@Pipe({
    name: 'memberNameForPickedPhoto',
    standalone: false
})
export class MemberNameForPickedPhotoPipe implements PipeTransform {
  transform(
    photoId: string,
    config: Record<
      string,
      { x: number; y: number; photoId: string; groupId: string }
    >,
    members: TabloMember[],
  ): string {
    if (typeof photoId !== 'string') {
      return '';
    }
    const memberConfig = Object.entries(config).find(
      ([, v]) => v.photoId === photoId,
    );
    if (!memberConfig) {
      return '';
    }
    const [memberId] = memberConfig;
    const member = members.find((v) => v.tabloMemberId === memberId);
    return `${member?.firstName} ${member?.lastName}`;
  }
}
